/**
 * AuthLayout — DS Layout
 * Centrage vertical/horizontal pour les pages d'authentification
 */

import styles from './AuthLayout.module.css';

interface AuthLayoutProps {
  children: React.ReactNode;
  logo?: React.ReactNode;
  className?: string;
}

export function AuthLayout({ children, logo, className = '' }: AuthLayoutProps) {
  return (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.card}>
        {logo && <div className={styles.logo}>{logo}</div>}
        {children}
      </div>
    </div>
  );
}
